import { atom } from 'recoil';

export const orgLogoAtomState = atom<string | undefined>({
    key: 'OrgLogoAtomState',
    default: undefined,
});
